var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionAddressBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -768.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Address-book",
    transform: "translate(824.000000, 768.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7142857,1 C29.0810714,1 31,2.91892857 31,5.28571429 L31,5.28571429 L31,26.7142857 C31,29.0810714 29.0810714,31 26.7142857,31 L26.7142857,31 L5.28571429,31 L5.28571429,1 Z M4.21428571,21.3571429 L4.21428571,27.7857143 C2.43892857,27.7857143 1,26.3467857 1,24.5714286 C1,22.7960714 2.43892857,21.3571429 4.21428571,21.3571429 L4.21428571,21.3571429 Z M25.6428571,17.0714286 L17.1892857,17.0714286 C13.6214286,17.0767857 10.7125,19.9332143 10.6428571,23.5 L10.6428571,23.5 L25.6428571,23.5 L25.6428571,17.0714286 Z M4.21428571,12.7857143 L4.21428571,19.2142857 C2.43892857,19.2142857 1,17.7753571 1,16 C1,14.2246429 2.43892857,12.7857143 4.21428571,12.7857143 L4.21428571,12.7857143 Z M17.6071429,7.42857143 C15.5360714,7.42857143 13.8571429,9.1075 13.8571429,11.1785714 C13.8571429,13.2496429 15.5360714,14.9285714 17.6071429,14.9285714 C19.6782143,14.9285714 21.3571429,13.2496429 21.3571429,11.1785714 C21.3571429,9.1075 19.6782143,7.42857143 17.6071429,7.42857143 Z M4.21428571,4.21428571 L4.21428571,10.6428571 C2.43892857,10.6428571 1,9.20392857 1,7.42857143 C1,5.65321429 2.43892857,4.21428571 4.21428571,4.21428571 L4.21428571,4.21428571 Z",
    id: 163
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionAddressBook);
export default __webpack_public_path__ + "static/media/navigation-and-action-address-book.723077a7.svg";
export { ForwardRef as ReactComponent };